// extracted by mini-css-extract-plugin
export default {"propertiesListContainer":"RepoPropertiesList-module__propertiesListContainer--Baf2B"};